import React from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import TramitesDashboard from '../pages/TramitesDashboard';
import EmpresasDashboard from '../pages/EmpresasDashboard';

/**
 * DashboardRouter - Routes to the correct dashboard based on the module slug
 * This solves the issue where generic routes like /m/:moduleSlug/dashboard
 * would always render the same Dashboard component regardless of the module
 */
const DashboardRouter = () => {
  const { moduleSlug } = useParams();

  // Map module slugs to their specific dashboard components
  const dashboardMap = {
    'tramites': TramitesDashboard,
    'tramites-y-tareas': TramitesDashboard,
    'empresas': EmpresasDashboard,
    // Default to main Dashboard for other modules
  };

  const DashboardComponent = dashboardMap[moduleSlug] || Dashboard;

  return <DashboardComponent />;
};

export default DashboardRouter;
